<template>
  <div class="investinglive-latest-news-article-slot__wrapper">
    <a-media
      :image="article.featuredImage"
      :image-aspect-ratio="$options.consts.aspectRatios.article"
      :video="article.featuredVideo"
      :video-aspect-ratio="$options.consts.aspectRatios.article"
      :url="article.canonicalUrl"
      force-url
      :rounded="true"
      class="investinglive-latest-news-article-slot__featured-media"
    />
    <a-dots-responsive
      :text="article.title"
      tag="h4"
      :link-props="{ to: article.canonicalUrl }"
      :settings="$options.consts.topicSettings"
      class="investinglive-latest-news-article-slot__title"
    />
    <time class="investinglive-latest-news-article-slot__timestamp">
      {{ publishDate }}
    </time>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import AMedia from 'shared/AMedia'
import { aspectRatios } from 'enums/aspectRatios'
import ADotsResponsive, { configADots } from 'shared/ADotsResponsive'
import scss from '@/utils/scss'

const { breakpoints } = scss

export default {
  name: 'AArticleSlotCategoryNews',
  components: { ADotsResponsive, AMedia },
  props: {
    article: propValidator([PROP_TYPES.OBJECT])
  },
  consts: {
    aspectRatios,
    topicSettings: {
      [breakpoints.aboveDesktopXl]: configADots(3, 22, true),
      [breakpoints.desktopXl]: configADots(4, 18, true),
      [breakpoints.desktopLg]: configADots(4, 22, true),
      [breakpoints.desktopMd]: configADots(4, 18, true),
      [breakpoints.tablet]: configADots(3, 18, true),
      [breakpoints.mobile]: configADots(3, 22, false)
    }
  },
  computed: {
    publishDate() {
      return this.$helper.formatDate.toDefault(this.article.publishedOn)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/local/styles/article';

.investinglive-latest-news-article-slot__wrapper {
  .investinglive-latest-news-article-slot__title {
    $margin-top: (
      $above-desktop-xl: 15px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
    @extend .article-slot-title;
  }

  .investinglive-latest-news-article-slot__timestamp {
    margin-top: 15px;
    display: block;

    @extend .timestamp;
  }
}
</style>
